type ClassNameValue = string | false | null | undefined | ClassNameValue[];

/**
 * Join class names from strings and nested Prisma style arrays.
 *
 * Prisma style helpers return arrays, sometimes nested. This flattens them,
 * removes falsy conditional classes, and joins the rest into a `className`
 * string without adding a dependency for such a small use case.
 */
export function joinClassNames(...inputs: ClassNameValue[]): string {
  const out: string[] = [];
  const walk = (value: ClassNameValue): void => {
    if (!value) return;
    if (Array.isArray(value)) {
      for (const item of value) walk(item);
      return;
    }
    out.push(String(value));
  };
  for (const input of inputs) walk(input);
  return out.join(" ");
}
